module.exports = __webpack_public_path__ + "static/img/digitalCurrency.2929d0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digitalCurrency.png
// module id = dBcl
// module chunks = 128